import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from '../../../../shared/services';

@Component({
  selector: 'app-matching-donation-card',
  templateUrl: './matching-donation-card.component.html',
  styleUrls: ['./matching-donation-card.component.scss']
})
export class MatchingDonationCardComponent implements OnInit {

  @Input() campaigner;
  @Input() matchingDonation;
  @Input() origin = 'card';
  constructor(
    public utilService: UtilService
  ) { }

  ngOnInit() {
  }

}
